export default __webpack_public_path__ + "static/epictetus-2a200291508b52c07e353a19246971d8.jpg";